// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__KeejE","close":"styles_close__ii3Wo","ttl":"styles_ttl__s0HU6","txt":"styles_txt__DDjXn","btn":"styles_btn__v++7+"};